<template>

  <div id="product-detail-page" class="row">
    <article class="col-12 product">
      <div class="row">
        <div class="col-12 product-header">
          <h2 v-if="loaded"><span v-if="nameP2">{{nameP2}}</span><span> {{nameP1}}</span></h2>
          <div class="separator fat-separator"></div>
        </div>
      </div>

      <div v-if="loaded" class="row container-scrollable">
        <div class="col-12 main-product-content">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 product-image">
              <!--<div class="ribbon-discount-round"><div class="ribbon-discount-wrap"><p>20%</p><p>voordeel</p></div></div>-->
              <img v-bind:src="(product.content.photos_detail ? product.content.photos_detail[0] : '')">
            </div>

            <div class="col-12 col-sm-12 col-md-6 col-lg-6 product-allergy-info">
              <div class="product-descr-web" v-html="product.content.description_web">

              </div>
              <div v-if="product.content.allergenen || allergyAdditions.length">
                <span class="separator fat-separator"></span>
                <span class="allergy-info-title"><translate item="AllergyInfoTitle" /></span>
                <span class="separator fat-separator"></span>

                <div class="row">
                  <div class="col-6 allergy-icon" v-for="allergyId in product.content.allergenen" v-bind:key="allergyId" :class="getAllergy('id'+allergyId).fontIcon">{{getAllergy('id'+allergyId).title}}</div>
                  <div class="col-6 allergy-icon" v-for="allergyId in allergyAdditions" v-bind:key="allergyId" :class="getAllergy('id'+allergyId).fontIcon">{{getAllergy('id'+allergyId).title}}</div>
                </div>
              </div>
            </div>


          </div>

          <!--<div style="height:300px;overflow:auto">{{product}}</div>-->

          <div :key="productGroup" v-for="productGroup in ['mainProduct', 'addonProduct1', 'addonProduct2', 'addonProduct3']">


            <!--Main Product, in case of a menu-->
            <order-item-extra-container v-if="product.content[productGroup] != null && (product.content[productGroup].length > 1 || productGroup != 'mainProduct')"
                                        :products="product.content[productGroup]"
                                        :className="'level0 ' + product.content[productGroup + 'View']"
                                        :quantity="extraQuantity"
                                        :parentId="0"
                                        :name="productGroup"
                                        :selection-type="product.content[productGroup + 'SelectType'] || 'radio'"
                                        :useSly="(product.content[productGroup + 'View'] != 'small')"
                                        v-on:extra-quantity-changed="extraQuantityChanged($event, 0, productGroup, 0)"
                                        :titel="product.content[productGroup + 'Titel']"></order-item-extra-container>


            <!--Loop through the selected products of each groups-->
            <div v-for="choosenProduct in selectedMainProduct[productGroup]" :key="choosenProduct.Id">
              <!-- Main product: preperation methods of the choosen mainProduct, addonproduct1, addonproduct2, addonproduct3  -->
              <order-item-extra-container v-if="choosenProduct.content.Product_preparationMethods != null"
                                          :products="choosenProduct.content.Product_preparationMethods"
                                          :className="'level1 ' + choosenProduct.content.preperationMethodsView"
                                          :quantity="extraQuantity"
                                          :parentId="choosenProduct.id"
                                          :name="productGroup"
                                          :useSly="(choosenProduct.content.preperationMethodsView != 'small')"
                                          :selection-type="choosenProduct.content.preperationMethodsSelectType || 'checkbox'"
                                          v-on:extra-quantity-changed="extraQuantityChanged($event, choosenProduct.id, productGroup + '_' + choosenProduct.id, $event.displayOrder)"
                                          :titel="getProductTitel(product.content[productGroup + 'SubTitel'],choosenProduct.content['productName'])"></order-item-extra-container>

              <!--https://projecten.vwa.nu/redmine/issues/12002
            Render the extra's of addonProduct1 group
          -->
              <order-item-extra-container v-if="choosenProduct.content.extra != null"
                                          :products="choosenProduct.content.extra"
                                          :className="'level1 ' + choosenProduct.content.extraView"
                                          :quantity="extraQuantity"
                                          :parentId="choosenProduct.id"
                                          :name="productGroup"
                                          :useSly="(choosenProduct.content.extraView != 'small')"
                                          :selection-type="choosenProduct.content.extraSelectType || 'radio'"
                                          v-on:extra-quantity-changed="extraQuantityChanged($event, choosenProduct.id, productGroup + '_2_' + choosenProduct.id, $event.displayOrder)"
                                          :titel="getProductTitel(choosenProduct.content['mainProductSubTitel'], choosenProduct.content['productName'])"></order-item-extra-container>

            </div>
          </div>

          <!-- preperation methods in case of a simple product  -->
          <order-item-extra-container v-if="product.content.Product_preparationMethods != null && product.content.Product_preparationMethods.length > 0"
                                      :products="product.content.Product_preparationMethods"
                                      :className="'level0 ' + product.content.preperationMethodsView"
                                      :quantity="extraQuantity"
                                      :parentId="0"
                                      :name="'prep'"
                                      :selection-type="product.content.preperationMethodsSelectType || 'checkbox'"
                                      :useSly="(product.content.preperationMethodsView != 'small')"
                                      v-on:extra-quantity-changed="extraQuantityChanged($event,0, 'prep' ,$event.displayOrder)"
                                      :titel="getProductTitel(product.content.mainProductTitel, product.content['productName'])"></order-item-extra-container>

          <!-- preperation methods seccond chooise in case of a menu -->
          <div v-for="choosenProduct in selectedMainProduct['prep']" :key="choosenProduct.Id">
            <order-item-extra-container v-if="choosenProduct.content.Product_preparationMethods != null"
                                        :products="choosenProduct.content.Product_preparationMethods"
                                        :className="'level1 ' + choosenProduct.content.preperationMethodsView"
                                        :quantity="extraQuantity"
                                        :parentId="choosenProduct.id"
                                        :name="productGroup"
                                        :useSly="(choosenProduct.content.preperationMethodsView != 'small')"
                                        :selection-type="choosenProduct.content.preperationMethodsSelectType || 'checkbox'"
                                        v-on:extra-quantity-changed="extraQuantityChanged($event, choosenProduct.id, 'prep_' + choosenProduct.id, $event.displayOrder)"
                                        :titel="getProductTitel(product.content['prepSubTitel'],choosenProduct.content['productName'])"></order-item-extra-container>
          </div>

          <!--:titel="product.content.mainProductTitel || 'Maak je keuze'"></order-item-extra-container>-->
          <!-- extras in case of a simple product -->
          <order-item-extra-container v-if="product.content.extra != null && product.content.extra.length > 0"
                                      :products="product.content.extra"
                                      :className="'level0 ' + product.content.extraView"
                                      :quantity="extraQuantity"
                                      :parentId="0"
                                      :name="'extra'"
                                      :selection-type="product.content.extraSelectType || 'radio'"
                                      :useSly="(product.content.extraView != 'small')"
                                      v-on:extra-quantity-changed="extraQuantityChanged($event,0,'extra',$event.displayOrder)"
                                      :titel="getProductTitel(product.content.mainProductSubTitel,product.content['productName'])"></order-item-extra-container>
          <!--:titel="product.content.mainProductSubTitel || 'Maak je keuze'"></order-item-extra-container>-->

          <div v-if="product.content.linkToDish && showToDish" class="row message-want-menu">
            <div class="col-12">
              <span class="separator fat-separator"></span>
            </div>
            <div class="menu-message-wrap">
              <div class="row">
                <div class="col-8 col-sm-12 want-menu-description">
                  <div class="ribbon-discount-round">
                    <div class="ribbon-discount-wrap">
                      <p><translate item="WantMenuRibbonDiscountWrap" /></p>
                    </div>
                  </div>
                  <h4><translate item="WantMenuRibbonDiscountTitle" /></h4>
                  <p><translate item="WantMenuRibbonDiscountDescription" /></p>
                </div>
              </div>

              <div class="row want-menu-controls">
                <div class="col-6">
                  <button class="btn btn-default btn-big todish-confirm" v-on:click="loadDish()"><translate item="WantMenuToDishConfirm" /></button>
                </div>
                <div class="col-6">
                  <button class="btn btn-default btn-big btn-dark-grey todish-cancel" v-on:click="showToDish = false"><translate item="WantMenuToDishCancel" /></button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="product.content.linkToDish && !showToDish" class="row message-want-no-menu">

            <div class="col-12 menu-message-wrap">
              <div class="row">
                <div class="col-12 want-no-menu-description">
                  <h4><translate item="WantNoMenuTitle" /></h4>
                  <p><translate item="WantNoMenuDescription" /></p>
                </div>
              </div>

              <div class="row want-no-menu-controls">
                <div class="col-12">
                  <button class="btn btn-default btn-big btn-dark-grey todish-confirm" v-on:click="loadDish()"><translate item="WantNoMenuToDishConfirm" /></button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div v-else class="row container-scrollable"></div>

      <div v-if="loaded" class="row detail-page-buttons">

        <div class="col-12">
          <div class="separator fat-separator"></div>
        </div>

        <div class="col-12 hide-mobile detail-page-controls">
          <button class="btn btn-default btn-red close-window-link"><span><translate item="AddToCartCancel" /></span></button>
          <button class="btn btn-default addtocart btn-with-pricelabel close-window-link" v-on:click="addToBasket"><span class="cart-button-price-field">{{totalPrice | toCurrency}}</span><span><translate item="AddToCartConfirm" /></span> </button>
          <amz-spinner v-model="initQuantity" v-on:input="inputChange"></amz-spinner>
        </div>

        <div class="col-12 show-mobile detail-page-controls">
          <div class="row">
            <div class="col-3">
            </div>
            <div class="col-6">
              <amz-spinner v-model="initQuantity" v-on:input="inputChange"></amz-spinner>
            </div>
            <div class="col-3">
              <button class="btn btn-default addtocart btn-with-pricelabel"><span class="cart-button-price-field">{{totalPrice | toCurrency}}</span></button>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <button class="btn btn-default btn-red close-window-link"><span><translate item="AddToCartCancel" /></span></button>
            </div>
            <div class="col-6">
              <button class="btn btn-default addtocart close-window-link" v-on:click="addToBasket"><span><translate item="AddToCartConfirm" /></span></button>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>

  import { services } from '../Services/Services'
  import orderItemMixin from './Mixins/orderItemMixin'
  import orderItemExtra from './order-item-extra.vue'
  import orderItemExtraContainer from './order-item-extra-container.vue'
  import amzSpinner from './amz-spinner.vue';
  import Vue from 'vue';
  import translate from './translate';

  export default {
    name: 'order-item-detail-overlay',
    components: { amzSpinner, orderItemExtra, orderItemExtraContainer, translate},
    data: function () {
      return {
        product: services.detailProduct,				// product chosen during search and click action
        initQuantity: 1,
        //  quantity: 1,
        productExtraRadioId: {},
        allergenen: {},
        allergyAdditions: [],
        totalPrice: 0,
        slyCarousels: [],
        showToDish: true,
        visible: false,
        waitfortimer: false
      };
    },
    computed: {
      loaded: function () {
        return (this.product && !!this.product.loaded);
      },
      nameP1: function () {
        if (this.loaded && this.product.name.indexOf(" ") != -1) {
          //return this.product.name.split(" ").shift();
          return this.product.name.split(" ").pop();
        }
        return this.product.name;
      },
      nameP2: function () {
        if (this.loaded && this.nameP1 !== this.product.name) {
          var fullName = this.product.name.split(" ");
          //fullName.shift();
          fullName.pop();
          return fullName.join(" ");
        }
        return "";
      },

    },
    watch: {
      quantity: function (val) {
        this.initQuantity = val;
      },

      // loaded switches off at start services.loadProduct();
      "product.loaded": function () {

        if (this.loaded) {

          this.visible = true;

          if (!this.waitfortimer) {
            // navstate is an global helper for setting the overlay's/showing hiding menus defined in site.js
            navState.setNavState('searchDetailContainer');
          }

          // reset quantity
          this.quantity = 1;

          //// set product amount to default
          //this.quantityChanged(this.quantity);

          // clear selected child products
          this.productExtras = {};

          // clear the radio selection
          this.productExtraRadioId = {};

          // clear the selected main product
          this.selectedMainProduct = {};

          this.showToDish = true;

          var childContent = ['mainProduct'];
          var displayOrder = 0;

          for (var index in childContent) {
            var key = childContent[index];
            // initial select the main product.
            if (this.product.content[key] && this.product.content[key].length > 0) {
              var id = this.product.content[key][0];

              Vue.set(this.productExtras, id, {
                quantity: 1, children: {}, displayOrder: displayOrder
              });


              this.productExtraRadioId[key] = id;
              this.selectedMainProduct[key] = [services.getProductExtra(id)];
            }
          }

          // recalculate total
          this._calculateAllergyAdditions();
          this._calculateDishPrice();

        }
        //process.nextTick(function () {
        //  $('#search-detail-page .container-scrollable').getNiceScroll().resize();
        //});

      }
    },
    methods: {
      /**
       * Input quantity change handler
       * @param {any} quantity - the quantity
       */
      inputChange: function (newQuantity) {
        this.quantityChanged(newQuantity);
      },
      scrollExtras: function () {
        //console.log('scroll');
      },

      getProductTitel: function (title, replace) {

        return title ? title.replace('{0}', replace) : '';
      },

      /*
       * Handles the navigation to another product ( e.g. single product to dish )
       **/
      loadDish: function () {
       
        navState.setNavState();
        services.loadProduct(this.product.content.linkToDish);

        var _this = this;
        _this.waitfortimer = true;

        // set a timer, to prevent showing the overlay before the close animation is finished
        window.setTimeout(function () {
          _this.waitfortimer = false;
          if (_this.loaded) {
            // navstate is an global helper for setting the overlay's/showing hiding menus defined in site.js
            navState.setNavState('searchDetailContainer');
          }
        }, 500);
      },

    },
    mounted: function () {
     // $('#search-detail-page .container-scrollable').getNiceScroll().resize();
    },
    updated: function () {
      //nicecscroll updated in above event for better rendering?
      process.nextTick(function () {
        var niceScroll = $('#search-detail-page .container-scrollable').getNiceScroll();
        if (niceScroll.length)
          niceScroll.resize();
      });
    },
    mixins: [orderItemMixin]
  }

</script>


<!--<div class="col-12 col-sm-6 col-md-6 col-lg-6">
  <div class="product-image-slider">
    <div id="carousel" class="carousel slide" data-ride="carousel">

      <div v-if="product.content.photos" class="carousel-inner">
        <div v-for="(photo, index) in product.content.photos" v-bind:key="index" class="carousel-item" :class="{'active' : index == 0}">
          <img v-bind:src="(photo.replace('width=200', 'width=400').replace('height=200', 'height=400'))" alt="Product Slide index">
        </div>
        <ol v-if="product.content.photos.length > 1" class="carousel-indicators">
          <li v-for="(photo, index) in product.content.photos" data-target="#carousel" :data-slide-to="{index}" :class="{'active' : index == 0}"></li>
        </ol>
        <a v-if="product.content.photos.length > 1" class="carousel-control-prev" href="#carousel" data-slide="prev">
          <span class="icon-up"></span>
        </a>
        <a v-if="product.content.photos.length > 1" class="carousel-control-next" href="#carousel" data-slide="next">
          <span class="icon-up"></span>
        </a>
      </div>
      <div v-else class="carousel-inner">
        <div class="carousel-item active">
          <img src="/Content/images/icons/placeholder_products.jpg" alt="Product" />
        </div>
      </div>
    </div>
  </div>
</div>-->



// WEBPACK FOOTER //
// Vue/Src/Components/order-item-detail-overlay.vue